import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'item-add',
    templateUrl: './item-add.component.html',
    styleUrls: ['./item-add.component.scss']
})

export class ItemAddComponent {
    modelHolder: NgModel[] = [];
    constructor(private dialogRef: MatDialogRef<ItemAddComponent>, @Inject(MAT_DIALOG_DATA) public config: ItemForm) {}

    onSubmit(form) {
        if (form.valid) {
            this.dialogRef.close(form.value);
        }
    }
}


export interface fields {
    label: string;
    name: string;
    placeholder: string;
    errorMsg: string;
    value?: string;
}

export interface ItemForm {
    title: string;
    controls: fields[];
    submitText: string;
}